// Add your custom JS here.

/* ===========================================
wrapper padding-top
=========================================== */

// Bind to the resize event of the window object

// jQuery(window).on("resize", function () {
// 	var navbarHeight = jQuery('#wrapper-navbar').height();
	
// 	console.log('navbarHeight: ', navbarHeight);
// 	jQuery('#wrapper').css({ marginTop : navbarHeight + 'px' });
// // Invoke the resize event immediately
// }).resize();


/* ===========================================
Sticky navbar
=========================================== */
// When the user scrolls the page, execute myFunction
window.onscroll = function() {stickNavbar()};

// Get the navbar
var navbar = document.getElementById("wrapper-navbar");

// Get the offset position of the navbar
var bottomNavbar = navbar.offsetTop + navbar.offsetHeight;

// Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
function stickNavbar() {
  if (window.pageYOffset >= bottomNavbar) {
    navbar.classList.add("sticky")
  } else {
    navbar.classList.remove("sticky");
  }
}


